import { render, staticRenderFns } from "./funnel.vue?vue&type=template&id=149c0bf3&"
import script from "./funnel.vue?vue&type=script&lang=js&"
export * from "./funnel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports